export default "__VITE_ASSET__CqJTgX9e__"